import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';

@Injectable({
  providedIn: 'root'
})
export class RequestTypeService {

  private readonly REQUEST_TYPE_SERVICE_URL = '/dpwsvc/v1/ext/code/';
  private readonly REQUEST_CODE: string = 'REQUEST_TYPE';

  private _reqType: Map<string, string> = new Map<string, string>();

  constructor(private http: HttpClient, private environmentService: EnvironmentService, private errorService: ErrorService) {
  }

  public getReqTypes() {
    this.http.get<Map<string, string>>(this.environmentService.getServer() +
                                      this.REQUEST_TYPE_SERVICE_URL +
                                      this.REQUEST_CODE).subscribe(res => {
      this._reqType = res;
    }, error => {
      this.errorService.processError(error);
    });
  }

  public get reqType(): Map<string, string> {
    return this._reqType;
  }
}
